import { createContext, useContext } from 'react';

// /chat 에서만 제공된다. 없으면(공유 화면 등) 코드블록에 「미리보기」 버튼을 그리지 않는다.
export const HtmlPreviewContext = createContext(null);

export const useHtmlPreviewContext = () => useContext(HtmlPreviewContext);
